import React from 'react';
import { Grid, Card, Typography, Table, TableBody, TableRow, TableCell, Chip, Box } from '@mui/material';

interface TechnicalInfoProps {
  technical_info: {
    total_dom_size: number;
    size: number;
    encoded_size: number;
    total_transfer_size: number;
    content_encoding: string;
    media_type: string;
    server: string;
    url_length: number;
    relative_url_length: number;
    broken_resources: boolean;
    broken_links: boolean;
    duplicate_title: boolean;
    duplicate_description: boolean;
    duplicate_content: boolean;
  };
}

const TechnicalInfo: React.FC<TechnicalInfoProps> = ({ technical_info }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
          <Typography variant="h6" gutterBottom>
            Tailles et transfert
          </Typography>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Taille DOM</TableCell>
                <TableCell>{Math.round(technical_info.total_dom_size / 1024)} KB</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Taille page</TableCell>
                <TableCell>{Math.round(technical_info.size / 1024)} KB</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Taille encodée</TableCell>
                <TableCell>{Math.round(technical_info.encoded_size / 1024)} KB</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Transfert total</TableCell>
                <TableCell>{Math.round(technical_info.total_transfer_size / 1024)} KB</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={6}>
        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
          <Typography variant="h6" gutterBottom>
            Configuration serveur
          </Typography>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Serveur</TableCell>
                <TableCell>{technical_info.server || 'Non spécifié'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Encodage</TableCell>
                <TableCell>{technical_info.content_encoding || 'Aucun'}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Type média</TableCell>
                <TableCell>{technical_info.media_type}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Longueur URL</TableCell>
                <TableCell>{technical_info.url_length} caractères</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Card>
      </Grid>
      
      <Grid item xs={12}>
        <Card variant="outlined" sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            État des ressources
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Chip 
                  label={technical_info.broken_resources ? 'Ressources cassées' : 'Ressources OK'}
                  color={technical_info.broken_resources ? 'error' : 'success'}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Chip 
                  label={technical_info.broken_links ? 'Liens cassés' : 'Liens OK'}
                  color={technical_info.broken_links ? 'error' : 'success'}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Chip 
                  label={technical_info.duplicate_title ? 'Titre dupliqué' : 'Titre unique'}
                  color={technical_info.duplicate_title ? 'warning' : 'success'}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Chip 
                  label={technical_info.duplicate_content ? 'Contenu dupliqué' : 'Contenu unique'}
                  color={technical_info.duplicate_content ? 'warning' : 'success'}
                />
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TechnicalInfo;
